import styled from 'styled-components';

export const PaymentInfoViewWrapper = styled.div`
  display: flex;
  & > div:first-child {
    margin-right: 48px;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }
`;
